import React from 'react';
import PropTypes from 'prop-types';

import { builderDispatch } from '../_utils/ui';
import {
  isPostalCodeLocal,
  shouldStripPostalCodeWhitespace,
} from '../_utils/validations';

import CartItemsChangeEvents from './cart-items-change-events';
import ZipcodePopover from './zipcode-popover';
import InvalidZipCodeWarning from '../_common/postal-code-input/invalid-postal-code-warning';
import Button from '../_common/button';
import translate from '../_utils/tools/translate';

class ZipcodeSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      zipCodeValid: false,
    };

    this.zipCodeField = undefined;
    this.setZipCodeField = (ref) => {
      this.zipCodeField = ref;
    };
  }

  componentDidMount() {
    const { zipCode } = this.context;

    this.setState({
      zipCodeValid: isPostalCodeLocal(zipCode),
    });
  }

  handleZipCodeKeyUp = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.handleZipCodeUpdateClick();
    }
  };

  handleZipCodeUpdateClick = () => {
    let zipCode = this.zipCodeField.value;

    if (shouldStripPostalCodeWhitespace()) {
      zipCode = zipCode.replace(/ /g, '');
    }

    const valid = isPostalCodeLocal(zipCode);

    this.setState(
      {
        zipCodeValid: valid,
      },
      () => {
        if (!valid) return;

        builderDispatch.dispatch({
          type: CartItemsChangeEvents.ZIP_CODE_CHANGE,
          value: zipCode,
        });
      },
    );
  };

  handleZipCodeCancelClick = () => {
    const { zipCode, hidePopover } = this.context;
    this.zipCodeField.value = zipCode;
    this.setState({
      zipCodeValid: isPostalCodeLocal(zipCode),
    });
    hidePopover();
  };

  handleZipCodeChange = (e) => {
    const zipCode = e.target.value.replace(/ /g, '');
    this.setState({
      zipCodeValid: isPostalCodeLocal(zipCode),
    });
  };

  render() {
    const { zipCodeValid } = this.state;
    const { zipCode, popoverOpen, showPopover } = this.context;

    return (
      <div className="zipcode-selector d-flex flex-column flex-md-row align-items-md-center">
        <Button
          className="btn-outline-info rounded-pill mb-2 mb-md-0 mr-md-2"
          id="popover-anchor"
          text="Change"
          aria-label={`Change ${translate('zip code')}`}
          onClick={showPopover}
        />
        {!zipCodeValid && (
          <InvalidZipCodeWarning className="text-center text-md-left" />
        )}
        <ZipcodePopover
          onRef={(ref) => this.setZipCodeField(ref)}
          popoverOpen={popoverOpen}
          zipCodeValid={zipCodeValid}
          zipCode={zipCode}
          handleZipCodeChange={this.handleZipCodeChange}
          handleZipCodeKeyUp={this.handleZipCodeKeyUp}
          handleZipCodeCancelClick={this.handleZipCodeCancelClick}
          handleZipCodeUpdateClick={this.handleZipCodeUpdateClick}
        />
      </div>
    );
  }
}

ZipcodeSelector.contextTypes = {
  zipCode: PropTypes.string,
  popoverOpen: PropTypes.bool,
  showPopover: PropTypes.func,
  hidePopover: PropTypes.func,
};

export { ZipcodeSelector };
